export { nanoid } from '../../core/transport.js';
export const RuleId = (prop) => (typeof prop === 'string' ? prop : null);
RuleId.isValid = (prop) => typeof prop === 'string';
//# sourceMappingURL=id.js.map